
function ListSVG() {
  return (
    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1921_74073)">
        <path d="M20 12V14H4V12H20ZM1 12C1.55 12 2 12.45 2 13C2 13.55 1.55 14 1 14C0.45 14 0 13.55 0 13C0 12.45 0.45 12 1 12ZM20 6V8H4V6H20ZM1 6C1.55 6 2 6.45 2 7C2 7.55 1.55 8 1 8C0.45 8 0 7.55 0 7C0 6.45 0.45 6 1 6ZM20 0V2H4V0H20ZM1 0C1.55 0 2 0.45 2 1C2 1.55 1.55 2 1 2C0.45 2 0 1.55 0 1C0 0.45 0.45 0 1 0Z" fill="#A0A0A0"/>
      </g>
      <defs>
        <clipPath id="clip0_1921_74073">
          <rect width="20" height="14" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export { ListSVG }